module.exports = __webpack_public_path__ + "static/media/user-md-chat.b2a0bd47.svg";